import React from 'react';
import './css/About.css'
import { Link } from 'react-router-dom';

const About: React.FC = () => {
    return (
        <div className="about-page">
            <div className="about-container">
                <div className="about-header">
                    <div className="title-section">
                        <h1 className="main-title">CROWN RESIDENCE</h1>
                        <p className="subtitle">Амжилттай хөршүүдийн сонголт – таны гэр бүлийн шинэ орон зай</p>
                    </div>
                </div>

                <section className="content-section">
                    <h2 className="section-title"> Байршлын давуу тал</h2>
                    <div className="section-content">
                        <p>
                            Орхон аймгийн Баян-Өндөр сумын Оюут баг, 2А хороололд баригдаж буй
                            Crown Residence нь таны гэр бүлийн хэрэгцээнд бүрэн нийцсэн,
                            үнэ цэнийг агуулсан орон сууцны цогц шийдэл юм.
                        </p>
                        <p>
                            Төв зам дагуу, ШУТИС-ийн зүүн талд байрлалтай бөгөөд:
                        </p>
                        <div className="area-selection">
                            <h3>  200–500 метрийн радиуст</h3>
                            <div className="area-grid">
                                <div className="area-block">
                                    <strong>300 хүүхдийн 2 цэцэрлэг</strong>
                                </div>
                                <div className="area-block">
                                    <strong>Эрүүл мэндийн төв</strong>
                                </div>
                                <div className="area-block">
                                    <strong>Төрийн үйлчилгээний байгууллагууд</strong>
                                </div>
                                <div className="area-block">
                                    <strong>Хороо </strong>
                                </div>
                                <div className="area-block">
                                    <strong>Өндөрлөг</strong>
                                </div>
                                <div className="area-block">
                                    <strong>ШУТИС </strong>
                                </div>
                                <div className="area-block">
                                    <strong>9 Эрдэнэ худалдааны төв </strong>
                                </div>
                                <div className="area-block">
                                    <strong>Номин агуулах худалдаа </strong>
                                </div>
                                <div className="area-block">
                                    <strong>Оргил худалдааны төв</strong>
                                </div>
                            </div>
                        </div>
                        {/* <div className="features-grid">
                            <div className="feature-item">
                                <span className="feature-text"></span>
                            </div>
                            <div className="feature-item">
                                <span className="feature-text"></span>
                            </div>
                        </div> */}
                        {/* <p className="highlight-text">
                            200–500 метрийн радиуст байрлана.
                        </p> */}

                        <p>
                            Хотын дэд бүтцийн төвлөрөл сайтай бүсэд байрласнаар
                            таны өдөр тутмын амьдралыг илүү тав тухтай, хялбар, найдвартай болгоно.
                        </p>
                    </div>
                </section>
                <section className="content-section">
                    <h2 className="section-title">Барилгын хийцлэл ба төлөвлөлт</h2>
                    <div className="section-content">
                        <ul className="feature-list">
                            <li>Бүрэн цутгамал хийцтэй, 9 баллд тэсвэртэй</li>
                            <li>12 давхар, орчин үеийн архитектуртай</li>
                            <li>Давхар бүрт ердөө 2 айл – тайван, чимээ багатай, хувийн орон зай бүхий төлөвлөлт</li>
                        </ul>

                        <div className="area-selection">
                            <h3>Талбайн сонголт:</h3>
                            <div className="area-grid">
                                <div className="area-block">
                                    <strong>A, Б блок:</strong> 80м² ба 120м²
                                </div>
                                <div className="area-block">
                                    <strong>С блок:</strong> 50м², 70м², 80м²
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="content-section">
                    <h2 className="section-title">Амьдрах орчин</h2>
                    <div className="section-content">
                        <div className="environment-stats">
                            <div className="stat-item">
                                <div className="stat-value">30%</div>
                                <div className="stat-label">ногоон байгууламж</div>
                            </div>
                            <div className="stat-item">
                                <div className="stat-value">10%</div>
                                <div className="stat-label">ил зогсоол</div>
                            </div>
                            <div className="stat-item">
                                <div className="stat-value">30%</div>
                                <div className="stat-label">хүүхдийн тоглоомийн талбай</div>
                            </div>
                            <div className="stat-item">
                                <div className="stat-value">61</div>
                                <div className="stat-label">автомашины далд зогсоол</div>
                            </div>
                        </div>
                        <p className="environment-description">
                            Тав тух, ногоон орчин, амар амгалан уур амьсгалыг бүрдүүлсэн
                        </p>
                    </div>
                </section>

                <section className="cta-section">
                    <h2> ЭРЭЛТТЭЙ БҮСЭД ХЯЗГААРТАЙ ТООНЫ БАЙР ҮЛДЛЭЭ</h2>
                    <p>Өнөөдөр л шиийдвэр гарга, ирээдүйд гэр бүл тань талархах болно </p>
                    <Link to='/contact'>
                        <button className="cta-button">Дэлгэрэнгүй мэдээлэл авах</button>
                    </Link>
                </section>
            </div>
        </div>
    );
};

export default About;